import { ConsentPolicy } from '@wix/wix-bootstrap-api';

function initConsentPolicyManager(
  baseUrl: string,
  consentPolicy?: ConsentPolicy,
) {
  try {
    window.consentPolicyManager?.init({
      baseUrl,
      consentPolicy,
    });
  } catch (error) {
    console.error(error);
  }
}

function initWixTagManager(language: string) {
  try {
    window.wixTagManager.init('TEMPLATES', language);
  } catch (error) {
    console.error(error);
  }
}

export function initCookieAndTagManagers({
  baseUrl,
  consentPolicy,
  language,
}: {
  baseUrl: string;
  consentPolicy?: ConsentPolicy;
  language: string;
}) {
  window.addEventListener('consentPolicyManagerReady', () => {
    initConsentPolicyManager(baseUrl, consentPolicy);
  });

  window.addEventListener('TagManagerLoaded', () => {
    initWixTagManager(language);
  });
}
